/**
 * ModuleRow Component
 * Displays module header row with bulk toggle checkbox
 */

import React from 'react';

const ModuleRow = ({ 
  module, 
  permissions, 
  roles, 
  isRoleLocked, 
  hasPermission, 
  toggleModuleForRole 
}) => {
  // Format module name: convert "roles_and_permissions" to "Roles And Permissions"
  const formatModuleName = (moduleName) => {
    return moduleName
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
      .toUpperCase();
  };

  return (
    <tr className="module-row">
      <td className="module-name">
        {formatModuleName(module)}
      </td>
      
      {/* Module checkbox for each role (toggle all in module) */}
      {roles.map(role => {
        const isLocked = isRoleLocked(role);
        const checkedCount = permissions.filter(perm => hasPermission(role.id, perm.id)).length;
        const totalCount = permissions.length;
        const allChecked = checkedCount === totalCount;
        const someChecked = checkedCount > 0 && checkedCount < totalCount;
        const isIndeterminate = someChecked;
        
        return (
          <td key={role.id} className="module-checkbox-cell">
            <label className="module-checkbox-wrapper">
              <input
                type="checkbox"
                checked={allChecked || someChecked}
                disabled={isLocked}
                onChange={() => toggleModuleForRole(role.id, permissions)}
                className={isLocked ? 'locked' : ''}
              />
              <span className={`checkbox-custom module-checkbox ${isLocked ? 'locked' : ''} ${allChecked ? 'checked' : ''} ${isIndeterminate ? 'indeterminate' : ''}`}>
                {allChecked && <i className="bi bi-check"></i>}
                {isIndeterminate && <i className="bi bi-dash"></i>}
              </span>
            </label>
          </td>
        );
      })}
    </tr>
  );
};

export default ModuleRow;

